var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headers,"items":_vm.desserts,"item-key":"name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }